import request from '@/utils/request'

const garbageType = {
  name: 'garbageType',
  state: {
    isGarbageTypeDetailLoading: false,
    garbageTypeDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_GARBAGETYPE_DETAIL_LOADING: (state, data) => {
      state.isGarbageTypeDetailLoading = data
    },
    SET_MODULES_GARBAGETYPE_DETAIL_DATA: (state, data) => {
      state.garbageTypeDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryGarbageTypeDetailData({ commit }, id) {
      commit('SET_IS_MODULES_GARBAGETYPE_DETAIL_LOADING', true)
      commit('SET_MODULES_GARBAGETYPE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/garbageType/garbageTypeDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_GARBAGETYPE_DETAIL_LOADING', false)
          commit('SET_MODULES_GARBAGETYPE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_GARBAGETYPE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetGarbageTypeDetailData({ commit }) {
      commit('SET_MODULES_GARBAGETYPE_DETAIL_DATA', {})
    },
    setGarbageTypeDetailData({ commit }, data) {
      commit('SET_MODULES_GARBAGETYPE_DETAIL_DATA', data)
    }
  }
}

export default garbageType
